import { render } from "./WorkShift.vue?vue&type=template&id=abd23f6a"
import script from "./WorkShift.vue?vue&type=script&lang=js"
export * from "./WorkShift.vue?vue&type=script&lang=js"

import exportComponent from "/build/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__